var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlgoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 25.5003L24 16.2695L26 16.2695L26 25.5003L24 25.5003Z",
    fill: "#23C29D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6211 25.0815C12.6211 24.5293 13.0688 24.0815 13.6211 24.0815H36.3797C36.932 24.0815 37.3797 24.5293 37.3797 25.0815V32.7739H35.3797V26.0815H14.6211V32.7739H12.6211V25.0815Z",
    fill: "#23C29D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5078 5.77668C24.8125 5.60504 25.1847 5.60504 25.4894 5.77668L37.1071 12.3213C37.786 12.7037 37.786 13.6813 37.1071 14.0638L25.4894 20.6084C25.1847 20.78 24.8125 20.78 24.5078 20.6084L12.8901 14.0638C12.2111 13.6813 12.2111 12.7037 12.8901 12.3213L24.5078 5.77668Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9986 7.7957L15.4183 13.1925L24.9986 18.5893L34.5788 13.1925L24.9986 7.7957ZM25.4894 5.77668C25.1847 5.60504 24.8125 5.60504 24.5078 5.77668L12.8901 12.3213C12.2111 12.7037 12.2111 13.6813 12.8901 14.0638L24.5078 20.6084C24.8125 20.78 25.1847 20.78 25.4894 20.6084L37.1071 14.0638C37.786 13.6813 37.786 12.7037 37.1071 12.3213L25.4894 5.77668Z",
    fill: "#23C29D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 32.6538C3 32.1015 3.44772 31.6538 4 31.6538H23.2414C23.7937 31.6538 24.2414 32.1015 24.2414 32.6538V44.5C24.2414 45.0523 23.7937 45.5 23.2414 45.5H4C3.44771 45.5 3 45.0523 3 44.5V32.6538Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 33.6538V43.5H22.2414V33.6538H5ZM4 31.6538C3.44772 31.6538 3 32.1015 3 32.6538V44.5C3 45.0523 3.44771 45.5 4 45.5H23.2414C23.7937 45.5 24.2414 45.0523 24.2414 44.5V32.6538C24.2414 32.1015 23.7937 31.6538 23.2414 31.6538H4Z",
    fill: "#23C29D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7578 32.6538C25.7578 32.1015 26.2055 31.6538 26.7578 31.6538H45.9992C46.5515 31.6538 46.9992 32.1015 46.9992 32.6538V44.5C46.9992 45.0523 46.5515 45.5 45.9992 45.5H26.7578C26.2055 45.5 25.7578 45.0523 25.7578 44.5V32.6538Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7578 33.6538V43.5H44.9992V33.6538H27.7578ZM26.7578 31.6538C26.2055 31.6538 25.7578 32.1015 25.7578 32.6538V44.5C25.7578 45.0523 26.2055 45.5 26.7578 45.5H45.9992C46.5515 45.5 46.9992 45.0523 46.9992 44.5V32.6538C46.9992 32.1015 46.5515 31.6538 45.9992 31.6538H26.7578Z",
    fill: "#23C29D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03516 35.7451H18.1731V37.2836H6.03516V35.7451Z",
    fill: "#23C29D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5508 35.7451H41.6887V37.2836H29.5508V35.7451Z",
    fill: "#23C29D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03516 39.1016H13.6214V40.64H6.03516V39.1016Z",
    fill: "#23C29D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgoGreen);
export default __webpack_public_path__ + "static/media/algo-green.dbba7f72df41dab203c151fad9b43fef.svg";
export { ForwardRef as ReactComponent };